import Marquee from "react-fast-marquee";

const ITEMS = [
  "IBA APPROVED TRANSPORTER",
  "15,000+ RELOCATIONS",
  "99.8% SAFE DELIVERY",
  "ZERO HIDDEN CHARGES",
  "GPS-TRACKED FLEET",
  "PAN-INDIA NETWORK",
];

export const MarqueeStrip = () => (
  <div className="marquee-strip" data-testid="trust-marquee">
    <Marquee speed={30} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span className="marquee-item" key={item}>
          {item}
          <span className="marquee-star" aria-hidden="true">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
